/**
 * Regras do Painel Geral compartilhadas com o Telão (at-130, 23/10/2026).
 *
 * "Parado" é a MESMA conta no card "Veículos parados" da Home e no selo da placa do Telão.
 * Com duas cópias, o card diria 23 parados e o telão mostraria 22 selos — e a divergência
 * apareceria como número errado, não como erro.
 */

/** Sem movimentação de esteira há mais que isto ⇒ parado (card da Home desde a at-46). */
export const LIMIAR_PARADO_HORAS = 48;
/** A partir daqui o selo do Telão fica vermelho (5 dias). */
export const LIMIAR_CRITICO_HORAS = 120;

export const dataSegura = (valor?: string | null): Date | null => {
  if (!valor) return null;
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
};

interface VeiculoComDatas {
  status?: string | null;
  statusUpdatedAt?: string | null;
  updatedAt?: string | null;
  createdAt?: string | null;
}

/**
 * Milissegundos desde a última mudança de esteira (fallback `updatedAt`, `createdAt`).
 * `null` quando o veículo não tem data nenhuma ou já foi entregue.
 */
export function msSemMovimentacao(car: VeiculoComDatas, agora: Date = new Date()): number | null {
  if (String(car.status || '').toUpperCase() === 'ENTREGA') return null;
  const desde = dataSegura(car.statusUpdatedAt) || dataSegura(car.updatedAt) || dataSegura(car.createdAt);
  if (!desde) return null;
  return agora.getTime() - desde.getTime();
}

export function horasSemMovimentacao(car: VeiculoComDatas, agora: Date = new Date()): number | null {
  const ms = msSemMovimentacao(car, agora);
  return ms === null ? null : ms / (60 * 60 * 1000);
}

export function estaParado(car: VeiculoComDatas, agora: Date = new Date()): boolean {
  const h = horasSemMovimentacao(car, agora);
  return h !== null && h >= LIMIAR_PARADO_HORAS;
}
